import { atom } from 'jotai';
import { OrgLocation } from './organizations.types';

export const organizationAtom = atom<OrgLocation | null>(null);
